import { useState, useEffect } from 'react';
import { API } from '../App.js';

/* Wer bin ich? — einmal pro Anmeldung gefragt.

   useRole steckt in App, AppShell und der Startseite, und die Anmeldungen
   fragen dieselben Endpunkte für ihre Rechte. Jeder Aufruf schickte bisher
   seine eigenen vier Anfragen los: beim Laden der Anmeldungen 15 statt 4,
   über HTTP/1.1 (sechs Verbindungen je Host) in der Warteschlange vor der
   Teilnehmerliste. Jetzt teilen sich alle eine Zusage. */
let rollenZusage = null;

export function ladeRolle() {
  if (!rollenZusage) {
    rollenZusage = Promise.all([
      API.isAdmin(),
      API.getNamiAdminGroups(),
      API.getCallerNamiID(),
      API.getGrantedEvents(),
    ]).then(([isAdmin, adminGroups, namiId, grantedEvents]) => ({
      isAdmin,
      adminGroups,
      namiId,
      grantedEvents,
    }));
    // Ein Fehlschlag soll nicht für die ganze Sitzung hängen bleiben.
    rollenZusage.catch(() => {
      rollenZusage = null;
    });
  }
  return rollenZusage;
}

/* Beim Ab- und Anmelden: Die nächste Person bekommt ihre eigene Rolle. */
export function vergissRolle() {
  rollenZusage = null;
}

export function useRole() {
  const [role, setRole] = useState(null);
  const [namiAdminGroups, setNamiAdminGroups] = useState([]);
  const [callerNamiId, setCallerNamiId] = useState(null);

  useEffect(() => {
    let lebt = true;
    ladeRolle()
      .then(({ isAdmin, adminGroups, namiId, grantedEvents }) => {
        if (!lebt) return;
        setCallerNamiId(namiId);
        setNamiAdminGroups(adminGroups);
        if (isAdmin) setRole('superadmin');
        else if (adminGroups.length > 0) setRole('groupAdmin');
        else if (grantedEvents.length > 0) setRole('granted'); // has event_rights but no admin roles
        else if (namiId) setRole('self');
        else setRole('limited');
      })
      .catch(() => {});
    return () => {
      lebt = false;
    };
  }, []);

  return { role, namiAdminGroups, callerNamiId, isAdmin: role === 'superadmin' };
}
